export const getSQL = (state: any) => state.sqltable;
export const getResults = (state: any) => getSQL(state).get('results');
